<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="judge">
        <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
          <el-page-header>
          </el-page-header>
        </router-link>
        <div class="content">

          <div class="title">投诉管理</div>
          <el-tabs v-model="activeName" @tab-click="handleClick">

            <el-tab-pane label="我的投诉" name = 0>
              <div class="item" v-for="item in List1" :key="item.id" @click="dialogVisible = true;link(item.id)">
                <div>
                  <div class="header">投诉对象: {{item.appuserMininame ? item.appuserMininame : item.appuserUsername}}
                    <div class="r">{{item.status == 0 ? '等待平台处理' : '处理结束'}}</div>
                  </div>

                </div>

                <div class="createtime">
                  {{item.createTime}}
                </div>
                <div class="complaincontent" v-html="item.complaintContent">
                </div>
              </div>

            </el-tab-pane>
            <el-tab-pane label="被投诉" name = 1>
              <div class="item" v-for="item in List2" :key="item.id" @click="dialogVisible = true;link(item.id)">
                <div>
                  <div class="header">投诉人:{{item.appuser2Mininame ? item.appuser2Mininame : item.appuser2Username}}
                    <div class="r">{{item.status == 0 ? '等待平台处理' : '处理结束'}}</div>
                  </div>

                </div>

                <div class="createtime">
                  {{item.createTime}}
                </div>
                <div class="complaincontent" v-html="item.complaintContent">
                </div>
              </div>

            </el-tab-pane>

          </el-tabs>
        </div>
      </div>
      <el-dialog title="投诉详情" :visible.sync="dialogVisible" width="35%">
        <div class="items">
          <div class="Lists" v-if="activeName == 0">
            <div class="l">投诉对象：</div>
            <div class="r">{{List.appuserMininame ? List.appuserMininame : List.appuserUsername}}</div>
          </div>
          <div class="Lists" v-if="activeName == 1">
            <div class="l">投诉人：</div>
            <div class="r">{{List.appuser2Mininame ? List.appuser2Mininame : List.appuser2Username}}</div>
          </div>
          <div class="Lists">
            <div class="l">投诉理由：</div>
            <div class="r">{{List.complaintContent}}</div>
          </div>
          <div class="Lists">
            <div class="l">投诉时间：</div>
            <div class="r">{{List.createTime}}</div>
          </div>
          <div class="Lists">
            <div class="l">处理状态：</div>
            <div class="r">{{List.status == 0 ? '等待平台处理' : '处理结束'}}</div>
          </div>
          <div class="Lists">
            <div class="l">处理结果：</div>
            <div class="r">{{List.processingResults}}</div>
          </div>
          <div class="Lists">
            <div class="l">处理时间：</div>
            <div class="r">{{List.processingTime}}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>

</div>
</template>

<script>
const List1 = []
const List2 = []
const List = []
import {
  outComplaint,
  inComplaint,
  detailComplaint
} from "../api/api"
import transparentheaders from "../components/transparentheaders.vue";

export default {
  data() {
    return {
      activeName: 0,
      userid: "",
      List1,
      List2,
      List,
      selectid: "",
      dialogVisible: false
    }
  },
  components: {
    transparentheaders
  },
  mounted() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
    this.getoutComplaint();
    this.getinComplaint();

  },
  methods: {
    handleClick() {

    },
    getoutComplaint() {
      outComplaint({
        appuserId2: this.userid,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          this.List1 = res.data.result.records
        }
      });
    },
    getinComplaint() {
      inComplaint({
        appuserId: this.userid,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          this.List2 = res.data.result.records
        }
      });
    },
    link(id) {
      this.selectid = id;
      this.getdetailComplaint()
    },
    getdetailComplaint() {
      detailComplaint({
        id: this.selectid
      }).then(res => {
        if (res.data.code == 200) {
          this.List = res.data.result;
          console.log(this.List)
        }
      });
    }
  },

}
</script>

<style lang="scss" scoped>
.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  height: 100vh;
}

.white {
  background: white;

}

.judge {
  padding: 20px;
  margin-top: 70px;
  display: flex;
  height: 840px;
  background: white;
}

.content {
  margin: 0 auto;
  width: 500px
}

.title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px
}

.item {
  font-size: 14px;
  color: #333;
  border: solid 1px rgb(10, 108, 255);
  border-radius: 15px;
  margin-bottom: 20px;
  padding: 15px
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: dashed 1px rgb(10, 108, 255);

}

.createtime {
  margin-bottom: 10px;
}

.Lists {
  margin-bottom: 15px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/judge.vue